import { Descriptions, Flex, Layout, Spin, Table, Typography, } from "antd";
import React from "react";
import { useParams } from "react-router-dom";
import ErrorMessages from "../common/ErrorMessages";
import HeaderScreen from "../common/HeaderScreen";
import ReportButton from "../components/common/ReportButton";
import { SECONDARY_COLOR, WHITE_COLOR } from "../constants/color";
import { URL_REPORT } from "../constants/urls";
import { PURE_CHEMICAL_STATUS_TH } from "../constants/string";
import { GET } from "../frameworks/HttpClient";
import { formatComma, dateToHumanString, } from "../frameworks/Util";
import _, { values } from "lodash";

export default function PureChemicalSummaryScreen() {
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    if(id){
      fetchData();
    }
  },[id])

  const fetchData = async() => {
    setLoading(true);
    setErrorMessages(null);
    try {
      const response = await GET(`${URL_REPORT.PURE_CHEMICAL_SUMMARY}${id}/`);
      setData(response.data);
    } catch (error) {
      setErrorMessages(error.errorMessages);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Layout>
      <HeaderScreen title={`รายละเอียดสต๊อกสารเคมีภัณฑ์`} 
        style={{ backgroundColor : SECONDARY_COLOR, 
          color : WHITE_COLOR, 
          fontSize : 18, 
          fontWeight: 'bolder'
        }}
        onClick={() => window.close()}
      />
      <Layout.Content style={{ margin: 24, minHeight: 280, padding: "0px 24px", }}>
        <Spin spinning={loading}>
          <ErrorMessages message={errorMessages}/>
          <Descriptions
          size='small'
            title={
              <Flex justify="space-between" align="center">
                ข้อมูลเบื้องต้น
                <ReportButton url={`${URL_REPORT.PURE_CHEMICAL_DETAIL}${id}/`}>พิมพ์รายงาน</ReportButton>
              </Flex>
            }
            bordered
            column={1}
            items={[
              { label: 'Lot Number', children: data?.lot_no },
              { label: 'วันที่นำเข้า', children: dateToHumanString(data?.input_date) },
              { label: 'วันที่ผลิต', children: dateToHumanString(data?.produce_date) },
              { label: 'วันที่หมดอายุ', children: dateToHumanString(data?.expire_date)},
              { label: 'ชื่อสารเคมี', children: `${data?.chemical_name} (${PURE_CHEMICAL_STATUS_TH[`${data?.is_qc_passed}`]})`},
              { label: 'ปริมาณนำเข้า', children: formatComma(data?.amount)},
          ]}/>
          <Typography.Title level={5}>การนำไปใช้งาน</Typography.Title>
          <Table
            size='small'
            bordered
            pagination={false}
            columns={[
              { title: 'ใช้งาน Lot Number', dataIndex: 'lot_no' },
              { title: 'วันที่ใช้งาน', dataIndex: 'created', render: (value) => dateToHumanString(value) },
              { title: 'ใช้งาน', dataIndex: 'amount', render: (value) => formatComma(value) },
              { title: 'คงเหลือ',  dataIndex: 'total', render: (value) => formatComma(value)},
            ]}
            dataSource={data?.mix_transactions}
            />
        </Spin>
      </Layout.Content>
    </Layout>
  )
}